import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Translate } from "../../../../language";
import { Link } from "react-router-dom";
import { deleteWinery, seeWineries } from "../../../actions/wineryActions";

export const WineryAdmin = ({ history }) => {
  const dispatch = useDispatch();
  const { wineriesList } = useSelector((state) => state.wineriesAdmin);
  useEffect(() => {
    dispatch(seeWineries());
  }, []);
  return (
    <div>
      {wineriesList.map((element) => (
        <div key={element._id} className="modal-options-social-list">
          <div className="row">
            <Link to="/Admin/Inventory/products"><h3>{element.name}</h3></Link>
            <p>Código</p>
            <p>{element.code}</p>
            <p>Ubicación</p>
            <p>{element.ubication.city}</p>
            <p>{element.ubication.state}</p>
            <div
              onClick={() => dispatch(deleteWinery(element._id))}
              className=""
            >
              {Translate("deleteWinery", "es")}
            </div>
            <div
              onClick={() => history.push("/Admin/UpdateWinery/" + element._id)}
              className="pointer "
            >
              Editar
            </div>
          </div>
        </div>
      ))}
      <Link to="/Admin/CreateWinery">Crear Bodega</Link>
    </div>
  );
};
